export default "0f3aec35a965bd17.svg"